export default "__VITE_ASSET__37f32e36__"